import { StateCreator } from "zustand";

export interface FolderPickerOpenState {
    [x: string]: HTMLElement | null;
}

export interface FolderPickerSlice {
    folderPickerOpen: FolderPickerOpenState;
    setFolderPickerOpen: (state: FolderPickerOpenState) => void;
    resetFolderPickerOpen: () => void;
}

const initialFolderPickerOpenState: FolderPickerOpenState = {};

export const createFolderPickerSlice: StateCreator<FolderPickerSlice, [], [], FolderPickerSlice> = (set) => ({
    folderPickerOpen: initialFolderPickerOpenState,

    setFolderPickerOpen: (state) => set({ folderPickerOpen: state }),
    resetFolderPickerOpen: () => set({ folderPickerOpen: initialFolderPickerOpenState }),
});

